import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';
import {
  logDevError,
  updateErrorMessage,
  updateSuccessMessage,
} from 'shared/alerts';

export const GENERATE_VET_TIX = gql`
  mutation CreateVetTix($input: CreateVetTixInput!) {
    createVetTix(input: $input)
  }
`;

export function useGenerateVetTix() {
  const [generateVetTix] = useMutation(GENERATE_VET_TIX);

  const createVetTix = useCallback(
    async (input) => {
      try {
        await generateVetTix({
          variables: { input },
          onCompleted: () =>
            updateSuccessMessage(
              'Successfully requested Vet Tix. A CSV will be emailed to you once all the ticket shave been created.'
            ),
          onError: () => updateErrorMessage('Error generating Vet Tix'),
        });
      } catch (error) {
        logDevError(error);
        updateErrorMessage('Error generating Vet Tix');
      }
      return true;
    },
    [generateVetTix]
  );

  return createVetTix;
}
